import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ArrowRight, Info } from "@phosphor-icons/react";

export const GestionFinalCta = () => {
  const { t } = useTranslation();

  return (
    <section
      data-testid="gestion-final-cta"
      className="relative py-24 md:py-32 bg-slate-950 overflow-hidden"
    >
      <div
        className="absolute inset-0 opacity-40"
        style={{
          background:
            "radial-gradient(circle at 80% 50%, rgba(123,97,255,0.35) 0%, transparent 50%), radial-gradient(circle at 20% 50%, rgba(77,208,225,0.25) 0%, transparent 50%)",
        }}
      />
      <div
        className="absolute inset-0 opacity-[0.07]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,1) 1px, transparent 1px)",
          backgroundSize: "64px 64px",
          maskImage:
            "radial-gradient(ellipse at center, black 30%, transparent 70%)",
        }}
      />

      <div className="relative max-w-5xl mx-auto px-6 md:px-12 text-center">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400">
          {t("gestion.final.kicker")}
        </p>
        <h2 className="mt-6 font-heading text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight leading-[1] text-white">
          {t("gestion.final.title")}
        </h2>
        <p className="mt-8 max-w-2xl mx-auto text-lg leading-relaxed text-slate-300">
          {t("gestion.final.subtitle")}
        </p>

        <div className="mt-12 flex flex-col items-center gap-4">
          <Link
            to="/contact"
            data-testid="gestion-final-cta-btn"
            className="group inline-flex items-center gap-2 rounded-full bg-white px-8 py-4 text-sm font-bold text-slate-900 transition-all hover:-translate-y-0.5 hover:shadow-2xl hover:shadow-white/20"
          >
            {t("gestion.final.cta")}
            <ArrowRight
              size={16}
              weight="bold"
              className="transition-transform group-hover:translate-x-1"
            />
          </Link>
          <p className="text-xs text-slate-500">
            {t("gestion.final.small")}
          </p>
        </div>

        <div
          data-testid="gestion-disclaimer"
          className="mt-20 mx-auto max-w-3xl rounded-2xl border border-white/10 bg-white/5 backdrop-blur-sm p-6 flex gap-4 text-left"
        >
          <Info
            size={18}
            weight="bold"
            className="shrink-0 mt-0.5 text-amber-300"
          />
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-amber-300">
              {t("gestion.final.disclaimer_title")}
            </p>
            <p className="mt-2 text-sm leading-relaxed text-slate-300">
              {t("gestion.final.disclaimer")}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GestionFinalCta;
